import baseApi from 'api/base.api'

const developmentApi = {
  ...baseApi,
  baseUrl: 'https://api.dev.jive.com',
  gotoBaseUrl: 'https://api.dev.goto.com',
  partnerAdminUrl: 'https://api.partner.dev.aur.goto.com/partner-admin',
}

export default developmentApi
